import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { MobileBottomMenu } from "./AppUserControls";
import TrialBanner from "@/components/TrialBanner";
import SuspendedOverlay from "@/components/SuspendedOverlay";
import { useIdleTimeout } from "@/hooks/useIdleTimeout";
import { useAuth } from "@/contexts/AuthContext";
import { contactService } from "@/services/contactService";
import { toast } from "@/components/ui/sonner";

interface AppLayoutProps {
  children: React.ReactNode;
  contentMode?: "scroll" | "fixed";
}

export function AppLayout({ children, contentMode = "scroll" }: AppLayoutProps) {
  useIdleTimeout();
  const { subscription_status, suspension_reason, trial_days_remaining } = useAuth();

  const handleContact = async () => {
    try {
      await contactService.requestUpgrade({ message: '' });
      toast.success('Upgrade request sent. A sales representative will contact you shortly.');
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to send upgrade request';
      toast.error(errorMessage);
    }
  };

  return (
    <>
      <SuspendedOverlay
        subscriptionStatus={subscription_status}
        suspensionReason={suspension_reason}
        onContact={handleContact}
      />
      <SidebarProvider>
        <div className="flex h-dvh w-full overflow-hidden">
          <AppSidebar />
          <SidebarInset className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
            <TrialBanner
              subscriptionStatus={subscription_status}
              trialDaysRemaining={trial_days_remaining}
              onContact={handleContact}
            />
            <main
              className={
                contentMode === "fixed"
                  ? "min-h-0 min-w-0 flex-1 overflow-hidden bg-background pb-16 md:pb-0"
                  : "min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto bg-background pb-20 md:pb-0"
              }
            >
              {children}
            </main>
            <MobileBottomMenu />
          </SidebarInset>
        </div>
      </SidebarProvider>
    </>
  );
}
